import { cn } from '@lib/utils';
import { memo } from 'react';
import { baseTableDataStyle } from './style';
import { ColumnRenderInfo } from './type';

interface TableCellProps<T extends Record<string, string>> {
  columnRenderInfo: ColumnRenderInfo<T>;
  row: T;
  className?: string;
}

function TableCellComponent<T extends Record<string, string>>({
  columnRenderInfo,
  row,
  className,
}: TableCellProps<T>) {
  return (
    <td className={cn(baseTableDataStyle, className)}>
      {columnRenderInfo.render(row[columnRenderInfo.key], row)}
    </td>
  );
}

// memoization 적용 columnRenderInfo.render 재실행 방지
const TableCell = memo(TableCellComponent) as typeof TableCellComponent;

export default TableCell;
